import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { FormControl, InputLabel, MenuItem, Radio, Select } from '@material-ui/core';
import { useSelector } from 'react-redux';
import InfoIcon from '@mui/icons-material/Info';
import { DataGrid } from '@mui/x-data-grid';
import { Stack, Tooltip, FormControlLabel, Menu, Box, Typography, Grid  } from '@mui/material';

import useStyles from './styles';
import { getFeatureEngagementList, getTimeEngagementList } from '../../redux/Actions/feature-engagement.action';
import { mapFeatures } from './mapFeatures';
import ClientsList from './clientsList';
import { ReactComponent as NoDocumentIcon } from '../../assets/images/no-document.svg';
import { ReactComponent as FilterIconOutlineIcon } from '../../assets/images/FIlterIconOutline.svg';
import InfoBox from '../../components/InfoBox/InfoBox';
import LoginMetrics from './loginMetrics';

const modulesList = [
    { id: 0, label: 'All', value: 'All' },
    { id: 1, label: 'Search Client', value: 'searchFeatures' },
    { id: 2, label: 'Tuning', value: 'tuningFeatures' },
    { id: 3, label: 'Analytics', value: 'analyticsFeatures' },
    { id: 4, label: 'NLP', value: 'nlpFeatures' },
];

const tabs = [
    { id: 0, label: 'Login Metrics Overview' },
    { id: 1, label: 'Feature Engagement Metrics' }
];

const menuList = [
    { id: 0, label: 'Yes', value: 'Yes' },
    { id: 1, label: 'No', value: 'No' },
];

const AdminPanelAdoption = () => {
    const resultsPerPage = 10;

    const [originalFeatureInsights, setOriginalFeatureInsights] = useState([]);
    const [featureInsights, setFeatureInsights] = useState([]);
    const [scheduleAnchorEl, setMenuAnchorEl] = useState(null);
    const [selectedMenus, setSelectedMenus] = useState('');
    const [subReport, setSubReport] = useState({ show: false, data: [] });
    const [featureLoading, setFeatureLoading] = useState(true);
    const [timeFeatureLoading, setTimeFeatureLoading] = useState(true);

    const [activeTab, setActiveTab] = useState(1);
    const [activeClient, setActiveClient] = useState('All');
    const [activeModule, setActiveModule] = useState('All');
    const [pagination, setPagination] = useState(0);
    const [clients, setClients] = useState([]);
    const [timeFeatureInsights, setTimeFeatureInsights] = useState([]);
    const [originalTimeFeatureInsights, setOriginalTimeFeatureInsights] = useState([]);

    const { allClients } = useSelector((state) => state.instance);

    const classes = useStyles();

    const handleTabChange = useCallback((event, newValue) => {
        setActiveTab(newValue);
    }, [setActiveTab]);

    const handleKeyDown = useCallback((event, newValue) => {
        if (event.key === "Enter" || event.key === " ") {
            handleTabChange(event, newValue);
        }
    }, [handleTabChange]);

    const handleClientChange = useCallback((event) => {
        setActiveClient(event.target.value);
    }, [setActiveClient]);




    const handleModuleChange = useCallback((event) => {
        setActiveModule(event.target.value);
    }, [setActiveModule]);

    const handleCloseMenu = useCallback(() => {
        setMenuAnchorEl(null);
    }, [setMenuAnchorEl]);

    const handleMenuPopupClick = useCallback((event) => {
        setMenuAnchorEl(event.currentTarget);
    }, [setMenuAnchorEl]);

    const handleMenuChange = useCallback((event) => {
        const selectedValue = event.target.value;
        setSelectedMenus(selectedValue);

        const tempFeatureInsights = originalFeatureInsights.filter(
            (item) => item.totalAccWithFeaActivated === selectedValue
        );

        setFeatureInsights(tempFeatureInsights);
    }, [setSelectedMenus, setFeatureInsights, originalFeatureInsights]);

    const handleSubReport = useCallback((event, row) => {
        if (activeClient === "All") {
            const clientsList = row.clientsList.map((name, index) => ({
                id: index + 1,
                name,
            }));

            setSubReport({ show: true, data: clientsList });
        }
    }, [activeClient, setSubReport]);

    const closeSubReport = useCallback(() => {
        setSubReport({ show: false, data: [] });
    }, []);

    const emptyTableMessage = useMemo(() => (
        <Stack
            height="100%"
            alignItems="center"
            justifyContent="center"
            className={classes.emptyDataText}
        >
            No Documents To show.
            <NoDocumentIcon className={classes.noDocumentIcon} />
        </Stack>
    ), [classes.emptyDataText]);

    const columns = useMemo(() => {
        const baseColumns = [
            {
                field: "feature",
                headerName: "Feature",
                sortable: false,
                flex: 1,
                headerAlign: "center",
                align: "center",
                minWidth: 100,
                renderCell: (params) => (
                    <div className={classes.row}>
                        <span className={classes.overflowText}>{params.row.feature}</span>
                    </div>
                ),
            },
            {
                field: "totalAccWithFeaActivated",
                headerName:
                    activeClient !== "All" ? "Enabled" : "Accounts with Feature Activated",
                sortable: false,
                flex: 1,
                headerAlign: "center",
                align: "center",
                minWidth: 100,
                renderCell: (params) => (
                    <div className={classes.row}>
                        <button
                            // onMouseEnter={(event) => handleSubReport(event, params.row)}
                            onClick={(event) => handleSubReport(event, params.row)}
                            className={`${classes.overflowText} ${activeClient === "All"
                                ? classes.accountWithFeature
                                : classes.enabled
                                }`}
                        >
                            {params.row.totalAccWithFeaActivated}
                        </button>
                    </div>
                ),
                renderHeader: () => (
                    <div className={classes.activatedFeaturesAccount}>
                        {activeClient !== "All"
                            ? "Enabled"
                            : "Accounts with Feature Activated"}
                        <FilterIconOutlineIcon onClick={handleMenuPopupClick} className={activeClient !== "All" ? classes.filterIcon : classes.hiddenDisplay} />
                        <Menu
                            id="fade-menu"
                            open={Boolean(scheduleAnchorEl)}
                            className={classes.menuList}
                            anchorEl={scheduleAnchorEl}
                            onClose={handleCloseMenu}
                            MenuListProps={{
                                "aria-labelledby": "fade-button",
                            }}
                        >
                            {menuList.map((item) => (
                                <MenuItem key={item.id} dense className={classes.menuItems}>
                                    <FormControlLabel
                                        label={item.label}
                                        control={
                                            <Radio
                                                name="menuRadio"
                                                value={item.value}
                                                checked={selectedMenus === item.value}
                                                onChange={handleMenuChange}
                                            />
                                        }
                                    />
                                </MenuItem>
                            ))}
                        </Menu>
                    </div>
                ),
            },
        ];

        if (activeClient === "All") {
            baseColumns.push({
                field: "engagement",
                headerName: (
                    <div className={classes.engagementPercentage}>
                        <p>Engagement %</p>
                        <span className={classes.icon}>
                            <Tooltip
                                placement="right"
                                title="Engagement % = ( accounts with feature activated/total number of accounts with feature access) x 100"
                            >
                                <InfoIcon
                                    className={classes.featureEngagement}
                                    sx={{ color: "#676868" }}
                                    fontSize="small"
                                />
                            </Tooltip>
                        </span>
                    </div>
                ),
                sortable: false,
                flex: 1,
                headerAlign: "center",
                align: "center",
                minWidth: 100,
                renderCell: (params) => (
                    <div className={classes.row}>
                        <span className={classes.overflowText}>{Number(params.row.engagement).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}%</span>
                    </div>
                ),
            });
        }

        return baseColumns;
    }, [activeClient, menuList, selectedMenus, scheduleAnchorEl, handleMenuPopupClick, handleCloseMenu, handleSubReport]);

    const timeEngagementColumns = useMemo(() => {
        const baseColumns = [
            {
                field: "feature",
                headerName: "Feature",
                sortable: false,
                flex: 1,
                headerAlign: "center",
                align: "center",
                minWidth: 100,
                renderCell: (params) => (
                    <div className={classes.row}>
                        <span className={classes.overflowText}>{params.row.feature}</span>
                    </div>
                ),
            },

            {
                field: "engagement",
                headerName: (
                    <div className={classes.engagementPercentage}>
                        <p>Engagement</p>
                    </div>
                ),
                sortable: false,
                flex: 1,
                headerAlign: "center",
                align: "center",
                minWidth: 100,
                renderCell: (params) => (
                    <div className={classes.row}>
                        <span className={classes.overflowText}>{params.row.avgDiffInDays.toFixed()}</span>
                    </div>
                ),
            }
        ];

        return baseColumns;
    }, []);

    useEffect(() => {
        if (allClients?.length && allClients[0]?.clients) {
            setClients(allClients[0].clients);
        }
    }, [allClients]);

    useEffect(() => {
        setFeatureInsights([]);
        const query = {
            pageNumber: pagination,
            limit: resultsPerPage,
        };

        if (activeClient !== 'All') query.client = activeClient;
        if (activeModule !== 'All') query.module = activeModule;

        setFeatureLoading(true);

        getFeatureEngagementList(query).then(res => {
            const { features, count } = res;
            const featureInsights = features.map((item, index) => ({
                totalAccWithFeaActivated: typeof item.totalEnabled === 'number' ? item.totalEnabled : item.enabled,
                id: index,
                feature: mapFeatures[item.feature] ? mapFeatures[item.feature] : item.feature,
                engagement: item.engagement,
                clientsList: item.clientsList ?? [],
            }));

            setFeatureInsights(featureInsights);
            setOriginalFeatureInsights(featureInsights);
            setSelectedMenus('');
            setFeatureLoading(false);
        });
    }, [pagination, activeClient, activeModule]);

    useEffect(() => {
        const query = {};

        setTimeFeatureInsights([]);
        setTimeFeatureLoading(true);
        if (activeClient !== 'All') query.client = activeClient;
        if (activeModule !== 'All') query.module = activeModule;

        getTimeEngagementList(query).then(res => {
            const { timeEngagementList } = res;

            const list = timeEngagementList.map((item, index) => ({
                ...item,
                feature: mapFeatures[item.feature] ? mapFeatures[item.feature] : item.feature,
                id: index,
            }));

            setTimeFeatureInsights(list);
            setOriginalTimeFeatureInsights(list);
            setTimeFeatureLoading(false);
        });

    }, [activeClient, activeModule]);

    return (
        <div>
            <div className={classes.tabs}>
                {tabs.map((item, index) => (
                    <div
                        key={index}
                        onClick={(event) => handleTabChange(event, item.id)}
                        onKeyDown={(event) => handleKeyDown(event, item.id)}
                        role="button"
                        tabIndex={item.id}
                        className={`${classes.tab} ${activeTab === item.id ? classes.active : null}`}
                    >
                        {item.label}
                    </div>
                ))}
            </div>

            {
                activeTab === 0 &&
                <LoginMetrics/>
            } 
            {
                activeTab === 1 &&
                <div className={classes.tabViewContainer}>
                    <div className={classes.tabHeadingContainer}>
                        <p className={classes.heading}>High-Level feature Engagement Insights</p>
                        <div className={classes.formGroup}>
                            <FormControl variant="filled" className={classes.selectFromControl}>
                                <InputLabel id="client-select-label" className={classes.selectLabel}>
                                    Client
                                </InputLabel>
                                <Select
                                    labelId="client-select-label"
                                    id="client-select-box"
                                    value={activeClient}
                                    onChange={handleClientChange}
                                    label="Select an Instance"
                                    className={classes.inputLabel}
                                    displayEmpty
                                    inputProps={{
                                        'aria-label': 'Without label',
                                        classes: {
                                            icon: classes.selectIcon
                                        }
                                    }}
                                    disableUnderline
                                >
                                    <MenuItem value="All">All</MenuItem>
                                    {
                                        clients.map((item) => (
                                            <MenuItem value={item.tenantId} key={item.tenantId}>
                                                {item.name}
                                            </MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                            <FormControl variant="filled" className={classes.selectFromControl}>
                                <InputLabel id="client-select-label" className={classes.selectLabel}>
                                    Select Module
                                </InputLabel>
                                <Select
                                    labelId="client-select-label"
                                    id="client-select-box"
                                    value={activeModule}
                                    onChange={handleModuleChange}
                                    label="Select an Instance"
                                    className={classes.inputLabel}
                                    displayEmpty
                                    inputProps={{
                                        'aria-label': 'Without label',
                                        classes: {
                                            icon: classes.selectIcon
                                        }
                                    }}
                                    disableUnderline
                                >
                                    {
                                        modulesList.map((item) => (
                                            <MenuItem value={item.value} key={item.value}>
                                                {item.label}
                                            </MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                        </div>
                    </div>

                    <div className={classes.dataTable}>
                        <DataGrid
                            loading={featureLoading}
                            disableRowSelectionOnClick
                            className={classes.table}
                            rows={featureInsights}
                            columns={columns}
                            sx={{
                                maxHeight: '100%',
                                overflowX: 'auto',
                                '.MuiDataGrid-selectedRowCount': {
                                    visibility: 'hidden'
                                },
                                '& .MuiDataGrid-virtualScrollerContent': {
                                    height: '100% !important',
                                    width: '100% !important',
                                    marginTop: '0px !important'
                                },
                            }}
                            getRowId={(row) => row.id}
                            components={{
                                NoRowsOverlay: () => emptyTableMessage,
                                NoResultsOverlay: () => emptyTableMessage

                            }}
                            filterMode="server"
                            onPageChange={(newPage) => setPagination(newPage)}
                            disableColumnMenu
                            hideFooter
                            rowBuffer={10}
                        />
                    </div>

                    <div className={classes.timeFeatureEngagementContainer}>
                        <p className={classes.heading}>Time to Feature Engagement</p>
                        <Tooltip
                            placement="right-end"
                            title="Time to feature engagement measures the period between a feature's release (enabled on instance) to the customer and the first time a user interacts with it. Engagement = (Activation date - Feature reach date)"
                        >
                            <InfoIcon
                                sx={{ color: "#676868" }}
                                fontSize="medium"
                            />
                        </Tooltip>
                    </div>

                    <div className={classes.dataTable}>
                        <DataGrid
                            loading={timeFeatureLoading}
                            disableRowSelectionOnClick
                            className={classes.table}
                            rows={timeFeatureInsights}
                            columns={timeEngagementColumns}
                            sx={{
                                maxHeight: '100%',
                                overflowX: 'auto',
                                '.MuiDataGrid-selectedRowCount': {
                                    visibility: 'hidden'
                                },
                                '& .MuiDataGrid-virtualScrollerContent': {
                                    height: '100% !important',
                                    width: '100% !important',
                                    marginTop: '0px !important'
                                },
                            }}
                            getRowId={(row) => row.id}
                            components={{
                                NoRowsOverlay: () => emptyTableMessage,
                                NoResultsOverlay: () => emptyTableMessage

                            }}
                            filterMode="server"
                            onPageChange={(newPage) => setPagination(newPage)}
                            disableColumnMenu
                            hideFooter
                            rowBuffer={10}
                        />
                    </div>
                </div>
            }

            <ClientsList {...subReport} handleClose={closeSubReport} />
        </div>
    );
};

export default AdminPanelAdoption;